import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel } from '../validation/Form-Components';
import imgComplete from '../images/appComplete.png';
import imgPending from '../images/appHold.png';
import hybridAppImgPending from '../hybridImages/appStatusPending.png';
import hybridAppImgComplete from '../hybridImages/appStatusComplete.png';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import config from '../appconfig/config.json';
import CusSavePrint from '../components/CusSavePrint';
import CusCancelApp from '../components/CusCancelApp';
import CusGreenBtn from '../components/CusGreenBtn';
import storage from '../factory/StorageFactory.js';
import LoadingText from '../components/LoadingText';
import mData from '../hybriddata/mainform.json';
import NonLendingSolutions from '../hybridcontainers/NonLendingSolutions.jsx';
import nldata from '../hybriddata/nonlendingdata.json';
import UploadStatus from '../hybridcomponents/UploadStatus.jsx';
import loProcessingImg from '../hybridImages/appStatusLOProcessing.png'
import aipImgPending from '../hybridImages/AIPStatusPending.png';
import aipImgComplete from '../hybridImages/AIPStatusComplete.png';
import aipImgAPN from '../hybridImages/AIPStatusComplete.png';
import losData from '../hybriddata/loanstatusdata.json';


const HSubmitDetails = (props) => {

    const financeTypeIslamic = 'islamic';
    const financeTypeConventional = 'conventional';

    const applicantStatusComplete = 'submitted';
    const applicantStatusPending = 'pending';

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();

    const [completedApplicants, setCompletedApplicants] = useState([]);
    const [pendingApplicants, setPendingApplicants] = useState([]);

    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const [buttonPopup, setButtonPopup] = useState(false);
    const [isCancelling,setIsCancelling] = useState(false);
    const [showNonLending,setShowNonLending] = useState(true);

    //upload document status

    const [isFirstDocSectDone, setIsFirstDocSectDone] = useState(false);
    const [isSecondDocSectDone, setIsSecondDocSectDone] = useState(false);
    const [isThirdDocSectDone,setIsThirdDocSectDone] = useState(false);

    useEffect(() => {
        console.log('@SubmitDetails useEffect');
        console.log('USEEFFECT');
        window.scrollTo(0, 0);
        getStatusEnquiry();
        //clearData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
 
        if (props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response : '';
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            getCompletedAndPendingPerson(resData);
            setIsLoading(false);
        }
        else {
            //redirect to error 
            console.log('error');
        }
    }

    const getStatusEnquiry = () => {

        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        service.getStatusEnquiry(sid,rno).then( res => {
            
            let resData = res.data.model.fields.request;
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            getCompletedAndPendingPerson(resData);
            getUploadedDocStatus(rno);
        })
        .catch( err => {
            console.log('getStatus err: ',err);
            setIsLoading(false);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const getUploadedDocStatus = (rno) => {

        service.getDocumentStatus(rno).then( res => {
            
            let resData = res.data.model;
       
            if(resData !== null) {
                setIsFirstDocSectDone((resData.hasFinancialStatement === 'Y'||resData.hasManagementAccount === 'Y'||resData.hasDraftAccount === 'Y')?true:false);
                setIsSecondDocSectDone((resData.hasBankStatement === 'Y')?true:false);
                setIsThirdDocSectDone((resData.hasOTP === 'Y')?true:false);
            }
   
            setIsLoading(false);
        })
        .catch( err => {
            console.log('getDocumentStatus err: ',err);
            setIsLoading(false);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const showCompletionDateMsg = () => {
        let result = '';
        if (pendingApplicants.length !== 0) {  // pending
            if (response.SoleorNonSole === config.bizConst.Sole) {
                result = 'Please complete application before ' + response.StatusDtls.Deadline + ' to avoid re-applying';
            }
            else {
                //check if login user is the first user
                // if login user is first user, show sth.
                result = 'All directors/shareholders/business owners/partners to complete application before ' + response.StatusDtls.Deadline + ' to avoid re-applying'
            }
        }

        return result;
    }

    const getCompletedAndPendingPerson = (data) => {

        let completedArray = [], pendingArray = [];
        if (!Array.isArray(data.ApplicantsStatus)) {
            if (data.ApplicantsStatus.status.toLowerCase() === applicantStatusComplete) {
                completedArray.push(data.ApplicantsStatus)
            }
            else {
                pendingArray.push(data.ApplicantsStatus);
            }
        }
        else {
            for (let i in data.ApplicantsStatus) {

                if (data.ApplicantsStatus[i].status.toLowerCase() === applicantStatusComplete) {
                    completedArray.push(data.ApplicantsStatus[i]);
                }
                else {
                    pendingArray.push(data.ApplicantsStatus[i]);
                }
            }
        }

        setCompletedApplicants(completedArray);
        setPendingApplicants(pendingArray);
        setIsLoading(false);
    }

    //export and print pdf
    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: response.StatusDtls.ApplicationNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSStatusDetails');
        return url;
    }

    const handleCancelApplication = () => {
        //do cancel api here.
        setIsCancelling(true);
        service.cancel(refNo,uen).then(res => {
            setIsCancelling(false);
            if (res.data.isSucess) {
                //cancel success
                setButtonPopup(false);
                props.history.push(config.route.AppCancelled);
            }
        })
        .catch(err => {
            console.log('err: ', err);
            setIsCancelling(false);
        })
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    
    const showDeadlineDate = () => {
        if(pendingApplicants.length !== 0 && response.StatusDtls.Deadline !== null) {
            return response.StatusDtls.Deadline;
        }
        return 'DDMMYYYY';
    }
 
    
    const showProgressText = () => {
        let result = 'Keep an eye out for updates as we will be in touch with you shortly';
      
        if(pendingApplicants.length > 0) {
            if(response.SoleorNonSole === config.bizConst.NonSole) {
                if(!Array.isArray(response.ApplicantsStatus)){
                    result = 'Submission in Progress';
                }
                else {
                    result = 'Joint Application in Progress ('+completedApplicants.length+'/'+response.ApplicantsStatus.length+' Done)';
                }
            }
            else { //Sole
                result = 'Submission in Progress';
            }
        }
        else { //All completed
            if(isPureAIP()) {
                result = 'Your Approval In-Principle application is currently being processed. Stay tuned for the status update.';
            }
            else {
                result = 'Keep an eye out for updates as we will be in touch with you shortly';
            }
          
        }

        return result;
    }

    const getPurposeString = () => {
        let result = '',temp = [];
        
        if(response.StatusDtls.WCL === 'Y') {
          temp.push(mData.label.chkWCL);
        }
        if(response.StatusDtls.Property === 'Y') {
          temp.push(mData.label.chkProperty);
        }
        if(response.StatusDtls.Trade === 'Y'){
          temp.push(mData.label.chkTrade);
        }
        if(response.StatusDtls.GAS === 'Y') {
          temp.push(mData.label.chkGAS);
        }
        if(response.StatusDtls.ESG === 'Y') {
            temp.push(mData.label.chkESG);
        }
      
        if(temp.length === 1) {
          result = temp[0];
        }
        else {
          result = temp.join(', ');
        }
        
        return result;
      }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }

    const getStatusData = () => {
        setIsLoading(true);
        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        service.getStatus(sid, rno).then(res => {
            let resData = res.data.model.fields.request;
         
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            getCompletedAndPendingPerson(resData);
          
            setIsLoading(false);
        })
        .catch(err => {
            console.log('err: ', err);
            setIsLoading(false);
        })
    }

    const handleNonLendingActionDone = () => {
        storage.setShowNonLending(false);
        getStatusData();
    }

    const isProductAIP = () => {
   
        if(response.StatusDtls.ProductType === config.bizFinancing.AIP) {
            return true;
        }

        return false;
    }

 
    const isPureAIP = () => {
        if(isProductAIP() && response.StatusDtls.isExistingOTPAvailable === 'N') {
            return true;
        }
            
        return false;
    }

    const disabledUploadDocs = () => {
        let result = false;
        if(storage.getIsFirstTime() === 'false'){
            if(storage.getIsGreenAP() === 'Y') {
                result = false;
            }
            else {
                result = true;
            }
        }
        // console.log('hideUploadDocs', result)
        return result;
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <div className="outerdivsubheader">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            {pendingApplicants.length === 0 ?
                                <div>
                                    <h2 className='completeTitle1 mb-0'>
                                    {(response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP || response.StatusDtls.ApplicationProgress === config.StatusDtls.APN)?
                                    <>
                                        {isPureAIP()?
                                        'Stay tuned for your Approval In-Principle application result.'
                                        :
                                        'Stay Tuned for your application result.'
                                        }
                                    </>
                                    :
                                    <>
                                        {(response.StatusDtls.ApplicationProgress === config.StatusDtls.AHB)?
                                        <>
                                            {'Stay Tuned for your application result.'}
                                        </>
                                        :
                                        <>
                                        {isPureAIP()?
                                        'Stay tuned for your Approval In-Principle application result.'
                                        :
                                        'Application submitted! Our sales team will be reaching out to you soon.'
                                        }
                                        </>
                                        }
                                    </>
                                    }
                                    </h2>
                                </div>
                                :
                                <div>
                                    {!Array.isArray(response.ApplicantsStatus)?
                                        <div>
                                            <h2 className='completeTitle1 mb-0'>{'Your online SME e-Financing application is currently on hold.'}</h2>
                                            <h2 className='completeTitle2'>{'You will receive email notification to review and complete the online application.'}</h2>
                                        </div>
                                        :
                                        <div>
                                            <h2 className='completeTitle1 mb-0'>
                                                {'We have received your application.'}
                                            </h2>
                                            <h2 className='completeTitle2'>
                                            {response.StatusDtls.ProductType === config.bizFinancing.BTL?
                                                'Subsequent person(s) will receive an email/SMS notification to review and complete the online application.'
                                                :
                                                'Authorised person will receive an email/SMS notification to review and complete the online application.'
                                            }
                                            </h2>
                                        </div> 
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                
                <FormContainer>
                    {(response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP || 
                        response.StatusDtls.ApplicationProgress === config.StatusDtls.APN ||
                        response.StatusDtls.ApplicationProgress === config.StatusDtls.AHB)?
                        <div className='statusImgHeader'>
                            {(response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP || 
                                response.StatusDtls.ApplicationProgress === config.StatusDtls.AHB)&&
                                <img src={loProcessingImg} alt="loanOfferProcessingImg" /> 
                            }
                            {response.StatusDtls.ApplicationProgress === config.StatusDtls.APN &&
                                <img src={aipImgAPN} alt="aipImgAPN" /> 
                            }
                        </div>
                        :
                        <div className='statusImgHeader'>
                            {isPureAIP()?
                                <img src={pendingApplicants.length === 0 ? aipImgComplete : aipImgPending} alt="imgScc1"></img>
                                :
                                <img src={pendingApplicants.length === 0 ? hybridAppImgComplete : hybridAppImgPending} alt="imgScc1"></img>
                            }
                           
                        </div>
                    }
                </FormContainer>

                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <h2 className='status-header-txt'>
                            {(response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP || 
                                response.StatusDtls.ApplicationProgress === config.StatusDtls.APN ||
                                response.StatusDtls.ApplicationProgress === config.StatusDtls.AHB)?
                                <>
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP && 
                                    <>{losData.yellowTitle.HLP}</>
                                }
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.APN && 
                                    <>{losData.yellowTitle.APN}</>
                                }
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.AHB && 
                                    <>{losData.yellowTitle.AHB}</>
                                }
                                </>
                            :
                            showProgressText()
                            }
                        </h2>
                    </div>

                    {((response.StatusDtls.ApplicationProgress !== config.StatusDtls.HLP) && 
                        (response.StatusDtls.ApplicationProgress !== config.StatusDtls.APN) &&
                        (response.StatusDtls.ApplicationProgress !== config.StatusDtls.AHB))&&
                        <div style={{ textAlign: "center", justifyContent: 'space-evenly' }} >
                        {(pendingApplicants.length === 0) &&
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <img className="imgScc" src={imgComplete} alt="imgScc"></img><br />
                                    <div className="bbline">Application Complete</div><br />
                                    {completedApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        }

                        {(completedApplicants.length === 0) &&
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <img className="imgScc" src={imgPending} alt="imgScc"></img><br />
                                    <div className="bbline">Application Pending</div><br />
                                    {pendingApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        }

                        {(pendingApplicants.length !== 0 && completedApplicants.length !== 0) ?
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <img className="imgScc" src={imgComplete} alt="imgScc"></img><br />
                                    <div className="bbline">Application Complete</div><br />
                                    {completedApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <img className="imgScc" src={imgPending} alt="imgScc"></img><br />
                                    <div className="bbline">Application Pending</div><br />
                                    {pendingApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div> : null
                        }
                        <br/>
                        </div>
                    }
              
                    {!disabledUploadDocs()&&
                    <UploadStatus history={props.history} firstIconGreen={isFirstDocSectDone} secIconGreen={isSecondDocSectDone} thridIconGreen={isThirdDocSectDone} />
                    }

                    <div style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>

                    <div style={{ marginLeft: '25px', margingRight: '25px' }}>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                            id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                            id={'uen'} name={response.StatusDtls.UEN} />
                   
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                            id={'facility'} name={response.StatusDtls.Facility} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                            id={'financeType'} name={response.StatusDtls.FinancingType} />

                        {!isPureAIP()&&
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                            id={'amt'} name={response.StatusDtls.Amount
                                ? response.StatusDtls.Amount != null
                                    ? 'SGD ' + parseFloat(response.StatusDtls.Amount)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : ""
                                : ""} />
                        }
                 
                        {isProductAIP()?
                            <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={'Property'} />
                            :
                            <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={getPurposeString()} />
                        }
                        
                        {(storage.getShowNonLending() !== 'true')&&
                        <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                            id={'combinedApp'} name={getNonLendingString()} />
                        }
 
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                            id={'date'} name={response.StatusDtls.AppDate} />

                        {isPureAIP() &&
                        <CusFormLabel leftLabelId={'lblAIPExpDate'} leftLabelName={'Approval In-Principle Expiry Date'}
                            id={'date'} name={'-'} />
                        }
                    </div>

                    <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>

                    {pendingApplicants.length !== 0 &&
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign:'center'}}>
                                <label className="box" id={'id77'}>Please complete application before {showDeadlineDate()} to avoid reapplying.</label>
                            </div>
                        </div>
                    }
                    
                    {pendingApplicants.length === 0 &&
                        <div style={{ textAlign: 'center', marginLeft: '20px', marginRight: '20px' }}>
                            <div style={{ color: 'gray', fontSize: '0.8em', fontWeight: 500 }}>{showCompletionDateMsg()}</div>
                        </div>
                    }

                    <br />

                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />

                    <div style={{ textAlign: "center" }} >
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome} />
                        <br />
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className='assit-txt'>
                                    <label>{losData.assitance.title}</label>&nbsp;
                                    <label className='add-btn-blue'>{losData.assitance.email}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <LoadingText show={isCancelling} setShow={setIsCancelling} label={'Cancelling..'} />
                    {(storage.getShowNonLending() === 'true')&&
                        <NonLendingSolutions trigger={showNonLending} setTrigger={setShowNonLending} response={response}
                            onActionDone={handleNonLendingActionDone}></NonLendingSolutions>  
                    }
                    </FormContainer>
                <br />
            </div>
        </PDFExport>
    )
}

export default HSubmitDetails;